/**
 * One ceiling for every user-supplied image, shared by client and server.
 *
 * These limits were scattered and inconsistent: a speaker portrait was capped at
 * 1.5 MB, an event flyer at 10 MB, and an authorized LinkedIn image at 5 MB, with
 * the portrait limit duplicated as a literal in both the browser and the router.
 * A phone photo routinely exceeds 1.5 MB, so the most common upload on the site
 * was also the one most likely to be rejected.
 *
 * The browser check exists to fail fast with a clear message. The server check is
 * the one that matters — a client-side limit is a courtesy, not a control, since
 * the request can be made without the page.
 */
export const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;

/** For copy: "10 MB". Derived so the number cannot drift from the limit. */
export const MAX_IMAGE_UPLOAD_LABEL = `${MAX_IMAGE_UPLOAD_BYTES / (1024 * 1024)} MB`;

/**
 * A base64 payload is about 4/3 the size of the bytes it encodes, plus the data
 * URL prefix. Routers that accept a data URL need the encoded ceiling, or a file
 * at exactly the limit is rejected for being too long as a string.
 */
export const MAX_IMAGE_UPLOAD_BASE64_LENGTH = Math.ceil(MAX_IMAGE_UPLOAD_BYTES * 4 / 3) + 1024;
